"use client";

import Link from "next/link";
import { useEffect } from "react";
import {
  primaryCtaClassName,
  secondaryCtaClassName,
  StatusPage,
} from "./_components/home/status-page";

export default function Error({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <StatusPage
      title="Something went wrong"
      description="Convert MD to PDF hit an unexpected error on this page. Try again, or return home and continue from there."
      detail={
        error.digest ? (
          <p className="mt-3 font-mono text-xs text-zinc-500">
            Error ID: {error.digest}
          </p>
        ) : null
      }
      actions={
        <>
          <button
            type="button"
            onClick={() => unstable_retry()}
            className={primaryCtaClassName}
          >
            Try again
          </button>
          <Link href="/" className={secondaryCtaClassName}>
            Go home
          </Link>
        </>
      }
    />
  );
}
